module.exports = __webpack_public_path__ + "static/media/upload-success-title@2x.d0e29cf9.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_31/imgs/upload-success-title@2x.png
// module id = 921
// module chunks = 0